(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-mobile-dropdown"] && !Shopify.designMode) return;
  try {
    class HeaderMobileDropdown extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.hmd-trigger');
    this.content = this.querySelector('.hmd-content');
    this.isOpen = false;

    if (this.trigger && this.content) {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });

      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.contains(e.target)) {
          this.close();
        }
      });
    }
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.classList.add('is-open');
    this.content.style.maxHeight = this.content.scrollHeight + 'px';
  }

  close() {
    this.isOpen = false;
    this.classList.remove('is-open');
    this.content.style.maxHeight = '0';
  }
}

if (!customElements.get('header-mobile-dropdown')) {
  customElements.define('header-mobile-dropdown', HeaderMobileDropdown);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-button"] && !Shopify.designMode) return;
  try {
    (function () {
    function initPopupBlock(wrapper) {
      if (wrapper.dataset.pbInit) return;
      wrapper.dataset.pbInit = '1';

      const blockId = wrapper.dataset.blockId;
      const modal = wrapper.querySelector('.popup-button-modal');
      if (!modal) return;

      // 親セクションの stacking context を抜け出すために body 直下へ移動
      document.body.appendChild(modal);

      function openModal() {
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        const inner = modal.querySelector('.popup-inner');
        inner.classList.add('popup-button-closing');
        inner.addEventListener('animationend', function handler(event) {
          if (event.animationName !== 'modalSlideOutTop') return;
          inner.removeEventListener('animationend', handler);
          inner.classList.remove('popup-button-closing');
          modal.setAttribute('hidden', '');
          document.body.style.overflow = '';
        });
      }

      // button-custom は <a> タグを出力するため preventDefault でナビゲーションを抑制
      const trigger = wrapper.querySelector('.block-button-custom a');
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          openModal();
        });
      }
      modal.querySelector('.popup-close').addEventListener('click', closeModal);
    }

    function initAll() {
      document.querySelectorAll('.popup-button-block').forEach(initPopupBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const sectionId = event.detail.sectionId;
      // body直下（移動済みの古いもの）だけ削除。新しいセクション内のモーダルは削除しない
      document.querySelectorAll('body > .popup-button-modal[data-section-id="' + sectionId + '"]').forEach(function (el) {
        el.remove();
      });
      const section = document.getElementById('shopify-section-' + sectionId);
      if (section) {
        section.querySelectorAll('.popup-button-block').forEach(initPopupBlock);
      }
    });

    // ブロック配置・選択時はポップアップを自動表示しない（trigger ボタンクリックで開く）
    document.addEventListener('shopify:block:select', function (event) {
      const wrapper = event.target.closest && event.target.closest('.popup-button-block');
      if (wrapper) initPopupBlock(wrapper);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["table-csv"] && !Shopify.designMode) return;
  try {
    (function () {
    function mergeCells(thead) {
      thead.querySelectorAll('tr').forEach(function (row) {
        var cells = Array.from(row.querySelectorAll('th'));
        for (var i = cells.length - 1; i > 0; i--) {
          var curr = cells[i].textContent.trim();
          var prev = cells[i - 1].textContent.trim();
          if (curr !== '' && curr === prev) {
            var currSpan = parseInt(cells[i].getAttribute('colspan') || '1', 10);
            var prevSpan = parseInt(cells[i - 1].getAttribute('colspan') || '1', 10);
            cells[i - 1].setAttribute('colspan', prevSpan + currSpan);
            cells[i].remove();
          }
        }
      });
    }

    function initScrollbar(block) {
      var scrollEl = block.querySelector('.table-csv-block__wrapper');
      var track = block.querySelector('.table-csv-block__scrollbar');
      var thumb = block.querySelector('.table-csv-block__scrollbar-thumb');
      if (!scrollEl || !track || !thumb) return;

      function update() {
        var ratio = scrollEl.clientWidth / scrollEl.scrollWidth;
        if (ratio >= 1) {
          track.hidden = true;
          return;
        }
        track.hidden = false;
        thumb.style.width = (ratio * 100) + '%';
        var scrollRatio = scrollEl.scrollLeft / (scrollEl.scrollWidth - scrollEl.clientWidth);
        thumb.style.left = (scrollRatio * (1 - ratio) * 100) + '%';
      }

      if (!block.dataset.sbInit) {
        block.dataset.sbInit = '1';

        scrollEl.addEventListener('scroll', update);

        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(update).observe(scrollEl);
        } else {
          window.addEventListener('resize', update);
        }

        var dragging = false, dragStartX, dragStartScroll;

        thumb.addEventListener('mousedown', function (e) {
          dragging = true;
          dragStartX = e.clientX;
          dragStartScroll = scrollEl.scrollLeft;
          e.preventDefault();
        });

        document.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
          var ratio = maxScroll / (track.clientWidth - thumb.offsetWidth);
          scrollEl.scrollLeft = dragStartScroll + (e.clientX - dragStartX) * ratio;
        });

        document.addEventListener('mouseup', function () { dragging = false; });

        track.addEventListener('click', function (e) {
          if (e.target === thumb) return;
          var rect = track.getBoundingClientRect();
          var ratio = (e.clientX - rect.left) / track.clientWidth;
          scrollEl.scrollLeft = ratio * (scrollEl.scrollWidth - scrollEl.clientWidth);
        });
      }

      update();
    }

    function initTableCsvBlock(wrapper) {
      var thead = wrapper.querySelector('.table-csv-block__table thead');
      if (thead) mergeCells(thead);
      initScrollbar(wrapper);
    }

    function initAll() {
      document.querySelectorAll('.table-csv-block').forEach(initTableCsvBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var sectionId = event.detail.sectionId;
      // setTimeout(0) で popup-button.liquid の section:load 処理（modal の body 移動）完了後に実行
      setTimeout(function () {
        document
          .querySelectorAll('.table-csv-block[data-section-id="' + sectionId + '"]')
          .forEach(initTableCsvBlock);
      }, 0);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var wrapper = event.target.closest && event.target.closest('.table-csv-block');
      if (wrapper) initTableCsvBlock(wrapper);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
